module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_HDR-removebg-preview-99ed7bc058d0461e689758318c13d9f6.png";